// extracted by mini-css-extract-plugin
module.exports = {"main":"style_main__3tGx2","link":"style_link__2rz9q"};